import axios from 'axios';
//import app from "@/main";

const authClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    }
})
/*authClient.interceptors.request.use(config => {
    app.config.globalProperties.$loading.value = true
    return config
})

authClient.interceptors.response.use(
    response => {
        app.config.globalProperties.$loading.value = false
        return response
    },
    error => error);*/
export default authClient;

